export enum TabsNames {
  Products = 'products',
  Recipes = 'recipes',
  Advices = 'advices',
}
